/* deals.gi - Master Cart Splitter v6.2 (Fixed Mapping + Verified Logic)
   FIXED: Resolved bucket misalignment and stale inventory caching.
*/

const DEALS_CONFIG = {
  primaryID: "47379906713",
  token: 'a0a4231db4c8bf3e06913cd6208ce166', 
  shop: 'gadget-station-gibraltar.myshopify.com',
  cacheKey: 'hdt_inventory_cache_v2' // Incremented version to clear old bad data
};

let currentMode = sessionStorage.getItem('userCartMode') || 'pickup'; 

const ICONS = {
  delivery: `<svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor"><path d="M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9l1.96 2.5H17V9.5h2.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"/></svg>`,
  pickup: `<svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/></svg>`
};

// --- MODAL LOGIC ---
window.openStoreInfo = function(locId) {
  const info = getLocInfo(locId);
  const overlay = document.createElement('div');
  overlay.className = 'hdt-store-modal-overlay';
  overlay.id = 'hdt-modal-overlay';
  overlay.style.display = 'flex';
  overlay.innerHTML = `
    <div class="hdt-store-modal">
      <span style="position:absolute; top:15px; right:15px; cursor:pointer; font-size:20px; color:#666;" onclick="closeStoreInfo()">×</span>
      <div class="hdt-modal-content">
        <h3 style="font-size:16px; font-weight:700;">${info.name} - Information</h3>
        <div style="margin-bottom:12px; font-size:13px;"><strong>📍 Address:</strong> ${info.addr}</div>
        <div style="margin-bottom:12px; font-size:13px;"><strong>⏰ Opening Hours:</strong> ${info.hours || 'Mon-Sat: 09:00 - 18:00'}</div>
        <div style="margin-bottom:12px; font-size:13px;"><strong>📞 Contact:</strong> ${info.tel}</div>
      </div>
    </div>`;
  document.body.appendChild(overlay);
};
window.closeStoreInfo = function() { const m = document.getElementById('hdt-modal-overlay'); if(m) m.remove(); };

// --- AGGRESSIVE RESTORATION ---
async function getCartData() {
  const res = await fetch('/cart.js');
  const liveCart = await res.json();
  const backup = localStorage.getItem('hdt_master_cart');
  const backupData = backup ? JSON.parse(backup) : null;

  if (backupData && backupData.items && (!liveCart.items || liveCart.items.length < backupData.items.length)) {
    const liveIds = new Set(liveCart.items ? liveCart.items.map(i => i.variant_id) : []);
    const missing = backupData.items.filter(i => !liveIds.has(i.variant_id));
    
    if (missing.length > 0) {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: missing.map(i => ({ id: i.variant_id, quantity: i.quantity })) })
      });
      const updatedRes = await fetch('/cart.js');
      const updatedCart = await updatedRes.json();
      localStorage.setItem('hdt_master_cart', JSON.stringify(updatedCart));
      return updatedCart;
    }
  }
  localStorage.setItem('hdt_master_cart', JSON.stringify(liveCart));
  return liveCart;
}

// --- INITIALIZATION WITH STRICT MAPPING ---
async function initCartSplit() {
  const target = document.getElementById('hdt-custom-split-cart-target');
  if (!target) return;

  const cart = await getCartData();
  window.allCartData = cart;
  
  if (!cart.items || cart.items.length === 0) {
    target.innerHTML = '<p style="text-align:center; padding:40px;">Your cart is empty.</p>';
    return;
  }

  // Create a fingerprint of the current cart to validate cache
  const cartFingerprint = cart.items.map(i => `${i.variant_id}:${i.quantity}`).join('|');
  const cached = sessionStorage.getItem(DEALS_CONFIG.cacheKey);
  const cachedData = cached ? JSON.parse(cached) : null;

  let invData;
  // Only use cache if the cart items exactly match the cached items
  if (cachedData && cachedData.fingerprint === cartFingerprint) {
    invData = cachedData.data;
  } else {
    // Generate unique Aliases to ensure strict mapping
    const qs = cart.items.map((i, idx) => `item_${i.variant_id}: node(id: "gid://shopify/ProductVariant/${i.variant_id}") { ... on ProductVariant { storeAvailability(first: 10) { edges { node { available location { id } } } } } }`).join('');
    
    try {
      const r = await fetch(`https://${DEALS_CONFIG.shop}/api/2025-07/graphql.json`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': DEALS_CONFIG.token },
        body: JSON.stringify({ query: `{ ${qs} }` })
      });
      const json = await r.json();
      invData = json.data;
      // Save with fingerprint to prevent mixups
      sessionStorage.setItem(DEALS_CONFIG.cacheKey, JSON.stringify({ fingerprint: cartFingerprint, data: invData }));
    } catch (e) { console.error("Inventory Fetch Error", e); }
  }

  let buckets = {};
  cart.items.forEach((item) => {
    // Access data by specific variant ID alias to prevent index mixups
    const node = invData[`item_${item.variant_id}`];
    let sIds = node?.storeAvailability?.edges?.filter(e => e.node.available).map(e => e.node.location.id.split('/').pop()) || [];
    
    let tL = sIds.length === 0 ? "preorder" : (sIds.includes(DEALS_CONFIG.primaryID) ? DEALS_CONFIG.primaryID : (sIds[0] || "unknown"));
    if (!buckets[tL]) buckets[tL] = [];
    buckets[tL].push(item);
  });

  renderUI(buckets);
}

// --- UI RENDERING ---
function renderUI(buckets) {
  const target = document.getElementById('hdt-custom-split-cart-target');
  const cartData = window.allCartData;
  const config = window.HDT_CartConfig;

  let html = '';
  if (config.deliveryEnabled && config.pickupEnabled) {
    html += `<div class="hdt-cart-mode-selector"><button class="hdt-mode-btn ${currentMode === 'shipping' ? 'active' : ''}" onclick="window.switchMode('shipping')">${ICONS.delivery} ${config.deliveryLabel}</button><button class="hdt-mode-btn ${currentMode === 'pickup' ? 'active' : ''}" onclick="window.switchMode('pickup')">${ICONS.pickup} ${config.pickupLabel}</button></div>`;
  }
  
  if (Object.keys(buckets).length > 1 && currentMode === 'pickup') {
    html += `<div class="hdt-cart-notice-bar"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg><div class="hdt-notice-text"><strong>Important Information</strong>Your items are at different stores/locations. Please complete each checkout separately.</div></div>`;
  }

  html += `<div class="hdt-split-cart-container">`;
  
  if (currentMode === 'shipping') {
    const minimal = cartData.items.map(i => ({ variant_id: i.variant_id, quantity: i.quantity }));
    html += renderBucketHTML('shipping', { name: "Home Delivery", addr: "Gibraltar-wide Delivery" }, cartData.items, minimal);
  } else {
    for (const [locId, items] of Object.entries(buckets)) {
      const info = getLocInfo(locId);
      const minimal = items.map(i => ({ variant_id: i.variant_id, quantity: i.quantity }));
      html += renderBucketHTML(locId, info, items, minimal);
    }
  }
  html += '</div>';
  target.innerHTML = html;
}

function renderBucketHTML(id, info, items, minimal) {
  const isShipping = id === 'shipping';
  const vIds = items.map(i => i.variant_id);
  
  return `
    <div class="hdt-location-bucket">
      <div class="hdt-location-header">
        <div style="display:flex; justify-content:space-between; align-items:center;">
          <div class="hdt-loc-name" style="display:flex; align-items:center; gap:8px;">
            ${isShipping ? ICONS.delivery : ICONS.pickup} ${info.name}
            ${!isShipping ? `<span style="font-size:11px; color:#000; font-weight: 500; margin-left:5px; cursor:pointer;" onclick="openStoreInfo('${id}')">More Info</span>` : ''}
          </div>
          ${!isShipping ? `<a href="javascript:void(0)" onclick="removeBucket('${id}', [${vIds}])" style="font-size:11px; color:#000; font-weight: 500;">Remove ALL</a>` : ''}
        </div>
        <div class="hdt-loc-info-row"><strong>Address:</strong> ${info.addr}</div>
        ${info.tel ? `<div class="hdt-loc-info-row"><strong>Contact:</strong> ${info.tel}</div>` : ''}
        ${info.note ? `<div class="hdt-store-note"><strong>Note:</strong> ${info.note}</div>` : ''}
      </div>
      <div class="hdt-bucket-content">
        ${items.map(i => `
          <div class="hdt-bucket-item">
            <a href="${i.url}" style="display:contents;"><img src="${i.image}"></a>
            <div style="flex:1">
              <a href="${i.url}" class="hdt-item-title">${i.product_title}</a>
              <div style="font-size:12px; color:#000; margin-top:4px;">Qty: ${i.quantity} | <a href="javascript:void(0)" onclick="removeItem(${i.variant_id})" style="color:#000; text-decoration:underline;">Remove</a></div>
            </div>
            <div style="font-weight:700; color:#000;">£${(i.line_price / 100).toFixed(2)}</div>
          </div>
        `).join('')}
      </div>
      <div class="hdt-bucket-discount-wrap" style="padding: 15px 20px 0 20px; border-top: 1px solid #F2F2F2;">
        <label style="display:block; font-size:13px; font-weight:600; margin-bottom:5px;">Discount Code:</label>
        <input type="text" id="discount-${id}" class="hdt-discount-input" placeholder="Enter code...">
        <div id="error-${id}" style="color:#ff4d4d; font-size:11px; margin-top:5px; display:none;"></div>
      </div>
      <div class="hdt-bucket-note-wrap" style="padding: 10px 20px 15px 20px;">
        <label style="display:block; font-size:13px; font-weight:600; margin-bottom:5px;">${isShipping ? 'Order Notes' : 'Pickup Notes'}:</label>
        <textarea id="note-${id}" style="width:100%; border:1px solid #e0e0e0; border-radius:6px; padding:10px; font-size:13px; min-height:60px;" placeholder="Add notes..."></textarea>
      </div>
      <div class="hdt-bucket-footer">
        <button type="button" data-items='${JSON.stringify(minimal)}' onclick="checkoutBucket('${id}', this)" class="hdt-checkout-btn">
          ${id === 'preorder' ? 'Pre-order Items →' : (isShipping ? 'Proceed to Checkout →' : 'Pay & Collect →')}
        </button>
      </div>
    </div>`;
}

// --- LOCATION METADATA ---
function getLocInfo(id) {
  const s = {
    "88853217516": { name: "The Food Store", addr: "100-102 Irish Town", tel: "+350 200 12345", hours: "Mon-Fri: 11:00 - 19:00", note: "Available in-shop. Order online to reserve or visit us directly." },
    "89446875372": { name: "The Gadget Shop - Airport", addr: "Departure Terminal, GIB Airport", tel: "+350 200 54321", hours: "Daily: 06:00 - 22:00 - based on flight schedule", note: "Shop is open 2 hours before departure." },
    "89446318316": { name: "Warehouse Product", addr: "73 Main Street, Gibraltar (ready in a few hours)", tel: "+350 200 60234", hours: "Mon-Fri: 10:00 - 19:00, Sat: 10:00 - 17:00, Sun: 11:00 - 15:00", note: "Warehouse product: Online order required for later collection." },
    "47379906713": { name: "The Gadget Shop", addr: "73 Main Street, Gibraltar", tel: "+350 200 60234", hours: "Mon-Fri: 10:00 - 19:00, Sat: 10:00 - 17:00, Sun: 11:00 - 15:00", note: "Available in-shop. Order online to reserve or visit us directly." },
    "89446908140": { name: "The Home Shop", addr: "11 John Mackintosh Square, Gibraltar", tel: "+350 200 60234", hours: "Mon-Fri: 10:00 - 19:00, Sat: 10:00 - 14:00", note: "Available in-shop. Order online to reserve or visit us directly." },
    "preorder": { name: "Pre-order Items", addr: "73 Main Street, Gibraltar", tel: "+350 200 60234", hours: "Mon-Fri: 10:00 - 19:00, Sat: 10:00 - 17:00, Sun: 11:00 - 15:00", note: "This item is currently out of stock but available for pre-order. Delivery/Collection times may vary." }
  };
  return s[id] || { name: "Store", addr: "Gibraltar", tel: "", hours: "", note: "" };
}

// --- CHECKOUT & HELPERS ---
window.checkoutBucket = async function(locId, buttonElement) {
  const currentCart = await fetch('/cart.js').then(r => r.json());
  localStorage.setItem('hdt_master_cart', JSON.stringify(currentCart));
  const config = window.HDT_CartConfig;
  const nVal = document.getElementById(`note-${locId}`)?.value || '';
  const dVal = document.getElementById(`discount-${locId}`)?.value.trim().toUpperCase() || '';
  const eMsg = document.getElementById(`error-${locId}`);

  if (dVal !== '') {
    const aStr = currentMode === 'shipping' ? (config.allowedDeliveryCodes || "") : (config.allowedPickupCodes || "");
    const aCodes = aStr.toUpperCase().split(',').map(c => c.trim()).filter(c => c !== "");
    if (aCodes.length > 0 && !aCodes.includes(dVal)) {
      if (eMsg) { eMsg.innerText = "Code not valid for " + currentMode; eMsg.style.display = 'block'; return; }
    }
  }

  if(nVal) await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: nVal }) });
  
  const items = JSON.parse(buttonElement.getAttribute('data-items'));
  const iStr = items.map(i => `${i.variant_id}:${i.quantity}`).join(',');
  let url = `/cart/${iStr}`; 
  if (dVal !== '') { url += `?discount=${encodeURIComponent(dVal)}`; }
  window.location.href = url;
};

window.removeItem = async function(id) { 
  await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: id.toString(), quantity: 0 }) }); 
  localStorage.removeItem('hdt_master_cart'); 
  sessionStorage.removeItem(DEALS_CONFIG.cacheKey);
  location.reload(); 
};

window.removeBucket = async function(lId, vIds) { 
  if (!confirm("Remove all items in this section?")) return; 
  const u = {}; vIds.forEach(id => { u[id] = 0; }); 
  await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: u }) }); 
  localStorage.removeItem('hdt_master_cart'); 
  sessionStorage.removeItem(DEALS_CONFIG.cacheKey);
  location.reload(); 
};

window.switchMode = function(m) { 
  currentMode = m; 
  sessionStorage.setItem('userCartMode', m); 
  initCartSplit(); 
};

document.addEventListener('DOMContentLoaded', initCartSplit);